// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-receipt-commons-Notes-__Notes___1nB-v","title":"app-components-receipt-commons-Notes-__Notes___2seyJ","content":"app-components-receipt-commons-Notes-__Notes___fmuAU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/commons/Notes/Notes.css
// module id = 2229
// module chunks = 0